﻿import * as basicRotate from "../../lib/basicrotate/basicRotate.js";
/*import { colourPicker } from "./colour-picker.js";*/
function carImageSlider(selectors = null) {
    const selector = {
        img: '.slider-img',
        imgContainer: '.model-grid-item-img.img-cdn',
        colourPickerContainer: '.model-grid-item-colour',
        colourPicker: '.model-grid-item-colour',
        fullscreenBtn: '[data-slider-fullscreen]',
        fullscreenIcon: '[data-icon-fullscreen]',
        fullscreenIconExit: '[data-icon-fullscreen-exit]'
    }
    let basicRotateInstance;

    const el = {
        get images() { return basicRotateInstance.elem.querySelectorAll(selector.img) },
        get imagesContainer() { return document.querySelector(selector.imgContainer) },
        get colourPickerContainer() { return document.querySelector(selector.colourPickerContainer) },
        get iconFullscreen() { return document.querySelector(selector.fullscreenIcon) },
        get iconFullscreenExit() { return document.querySelector(selector.fullscreenIconExit) }
    }

    function applyOptions() {
        if (selectors != null) {
            Object.entries(selectors).forEach(([key, val]) => {
                //console.log(`${key}:${val}`);
                if (selector.hasOwnProperty(key)) {
                    if (selector[key] != val) {
                        Reflect.set(selector, key, val);
                    }
                }
            });
        }
        return selector;
    }

    function carImgLoaded(img) {
        const loader = img.nextElementSibling;
        img.classList.add('loaded');
        img.classList.remove('colourChange');
        
        if (loader) {
            
        }
    }
    function handleImgLoad(e) {
        const img = e.target;
        carImgLoaded(img);
    }

    function create() {
        basicRotateInstance = basicRotate.create(
            document.querySelector('.basicRotate'),
            {
                /*
                * Initial image.
                */
                index: 0,
                /*
                 * Rotate image by dragging.
                 */
                draggable: true,
                /*
                 * Dragging tolerance.
                 * Small number (1) = Very sensitive = Fast.
                 * Large number (∞) = Very insensitive = Slow.
                 */
                tolerance: 30
            }
        )
        let fullscreenStatus = false;
        
        //const isFullscreen => fullscreenStatus == true;
        //const images = basicRotateInstance.elem.querySelectorAll(selector.img);
        //const imagesContainer = ()=> document.querySelector(selector.imgContainer);
        //const colourPickerContainer = document.querySelector(selector.colourPickerContainer);
        //const iconFullscreen = document.querySelector(selector.fullscreenIcon);
        //const iconFullscreenExit = document.querySelector(selector.fullscreenIconExit);
        el.images.forEach((img, index) => {
            //img.addEventListener('load', handleImgLoad);
            img.onload = () => { carImgLoaded(img); }


            const activeImage = img.classList.contains('active');
            const placeholder = img.src;
            const src = img.dataset.src || img.src;
            const srcset = img.dataset.srcset || img.srcset;
            if (!activeImage) {
                img.dataset.placeholder = placeholder;
                img.srcset = srcset;
                //img.src = src;
                img.removeAttribute('data-src');
                img.removeAttribute('data-srcset');
            }
            img.src = src;
            img.classList.remove('waiting', 'hidden');
            //if (img.complete) {
            //    carImgLoaded(img);
            //}
        });
        document.querySelector('.basicRotate + .slider-nav-back').onclick = basicRotateInstance.prev
        document.querySelector('.basicRotate ~ .slider-nav-next').onclick = basicRotateInstance.next

        if (el.imagesContainer.requestFullscreen) {
            document.querySelectorAll(selector.fullscreenBtn).forEach((link) => {
                link.addEventListener('click', toggleFullScreen)
            });
        } else {
            // If the browser does not support fullscreen, hide the fullscreen icon.
            document.querySelectorAll(selector.fullscreenBtn).forEach((link) => {
                link.classList.add('d-none');
            });
        }

        el.imagesContainer.addEventListener('fullscreenchange', function (e) {
            if (document.fullscreenElement) {
                el.iconFullscreen.classList.add('d-none');
                el.iconFullscreenExit.classList.remove('d-none');
                addClonedColourPicker();
                document.body.classList.add('fullscreen');
                fullscreenStatus = true;
            } else {
                el.iconFullscreenExit.classList.add('d-none');
                el.iconFullscreen.classList.remove('d-none');
                removeClonedColourPicker();
                document.body.classList.remove('fullscreen');
                fullscreenStatus = false;
            }
        });

        return {
            rotateInstance: basicRotateInstance,
            images: el.images,
            imagesContainer: el.imagesContainer,
            colourPickerContainer: el.colourPickerContainer,
            fullscreenStatus: fullscreenStatus
        }
    }
    function toggleFullScreen(e) {
        e.preventDefault();
        //if (!document.fullscreenElement) {
        //    imagesContainer.requestFullscreen();
        //} else if (document.exitFullscreen) {
        //    document.exitFullscreen();
        //}

        if (document.fullscreenElement) {
            // exitFullscreen is only available on the Document object.
            document.exitFullscreen();
        } else {
            el.imagesContainer.requestFullscreen();
        }
    }

    function addClonedColourPicker() {
        const colourPicker = document.querySelector(selector.colourPicker);
        if (!colourPicker) return;
        //const clonedColourPicker = colourPickerContainer.cloneNode(true);
        //clonedColourPicker.querySelectorAll('.colour-picker-link').forEach((link) => { link.addEventListener('click', colourPicker.handleColourClick); });
        el.imagesContainer.appendChild(colourPicker);
    }
    function removeClonedColourPicker() {
        const colourPicker = el.imagesContainer.querySelector(selector.colourPicker);
        //clonedColourPicker.querySelectorAll('.colour-picker-link').forEach((link) => { link.removeEventListener('click', colourPicker.handleColourClick); });
        if (colourPicker) {
            //clonedColourPicker.remove();
            el.imagesContainer.insertAdjacentElement('afterend', colourPicker);
        }
    }


    const options = applyOptions();
    const sliderRotate = create();
    Object.defineProperty(sliderRotate, "isFullscreen", {
        get() {
            return this.fullscreenStatus;
        },
    });

    return {
        options: options,
        slider: sliderRotate
    }
}
export { carImageSlider };
